import { HeaderReview } from './header-review';
import { IStepControl, Step } from '../../../domains/wizard';
import { AddressReview } from './address-review';
import { ContactsReview } from './contacts-review';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../store';
import { observer } from 'mobx-react';

interface IProps {
  stepControl: IStepControl;
}

export const BillingStepReview = observer((props: IProps) => {
  const { t: tCommon } = useTranslation('');
  const { tenantStore, quoteStore, billingInformationStore } = useStore();
  const {
    displayNationalTaxId,
    displayStateTaxId,
    displayInvoiceAnalysisFields,
    displaySignerInformation,
    displaySignatoryPosition,
    displayNationalId,
    invoiceDueDays,
  } = tenantStore.config;
  return (
    <div className="avoid-break">
      <div className="container-grey m-bottom-30">
        <HeaderReview stepControl={props.stepControl} step={Step.Billing} />

        <div className="avoid-break">
          <h4>{tCommon('BILLING_INFORMATION.COMPANY_NAME')}</h4>
          <div className="container-readonly no-label">
            <span>{quoteStore.quoteInfo?.customer.name}</span>
          </div>

          {displayNationalTaxId && (
            <div>
              <h4>{tCommon('BILLING_INFORMATION.NATIONAL_TAX_ID')}</h4>
              <div className="container-readonly no-label">
                <span>{billingInformationStore.information.nationalTaxId.value}</span>
              </div>
            </div>
          )}

          {displayStateTaxId && (
            <div>
              <h4>{tCommon('BILLING_INFORMATION.STATE_TAX_ID')}</h4>
              <div className="container-readonly no-label">
                <span>{billingInformationStore.information.stateTaxId.value}</span>
              </div>
            </div>
          )}

          {displayInvoiceAnalysisFields && (
            <div>
              <h4>{tCommon('BILLING_INFORMATION.INVOICE_ANALYSIS_CONTACT_EMAIL')}</h4>
              <div className="container-readonly no-label">
                <span>{billingInformationStore.information.invoiceAnalysisContactEmail.value}</span>
              </div>

              <h4>{tCommon('BILLING_INFORMATION.INVOICE_ANALYSIS_CONTACT_PHONE')}</h4>
              <div className="container-readonly no-label">
                <span>{billingInformationStore.information.invoiceAnalysisContactPhone.value}</span>
              </div>
            </div>
          )}

          {!!invoiceDueDays && (
            <div>
              <h4>{tCommon('BILLING_INFORMATION.INVOICE_DUE_DAY')}</h4>
              <div className="container-readonly no-label">
                <span>
                  {tCommon('BILLING_INFORMATION.DAY_OF_THE_MONTH', { day: billingInformationStore.information.invoiceDueDay.value })}
                </span>
              </div>
            </div>
          )}
        </div>

        <hr />

        {displaySignerInformation && (
          <>
            <div className="avoid-break">
              <h4>{tCommon('BILLING_INFORMATION.SIGNATORY_INFORATION')}</h4>

              <div className="container-readonly">
                <label>{tCommon('BILLING_INFORMATION.FIRST_NAME')}</label>
                <span>{billingInformationStore.information.signerFirstName.value}</span>
              </div>
              <div className="container-readonly">
                <label>{tCommon('BILLING_INFORMATION.LAST_NAME')}</label>
                <span>{billingInformationStore.information.signerLastName.value}</span>
              </div>
              {displaySignatoryPosition && (
                <div className="container-readonly">
                  <label>{tCommon('BILLING_INFORMATION.SIGNATORY_POSITION')}</label>
                  <span>{billingInformationStore.information.signatoryPosition.value}</span>
                </div>
              )}
              {displayNationalId && (
                <div className="container-readonly">
                  <label>{tCommon('BILLING_INFORMATION.NATIONAL_ID')}</label>
                  <span>{billingInformationStore.information.nationalId.value}</span>
                </div>
              )}
            </div>
            <hr />
          </>
        )}

        <div className="avoid-break">
          <h4>{tCommon('BILLING_INFORMATION.BILLING_ADDRESS')}</h4>
          <AddressReview addressType={'billing'} />
        </div>
        <hr />
        <ContactsReview contactsType={'billing'} />
      </div>
    </div>
  );
});
